import rfpListTemplate from './rfpList.html';
import rfpListFilterModalTemplate from './rfpListFilterModal.html';

const rfpFilterModal = {
    bindings: {
        onSearch: '=',
        onSort: '=',
        rfps: '=',
        count: '=',
        searchText: '=',
        filterIndicationText: '=?',
        callingPage: '=?',
        updateDisable: '=',
        openModal: '=',
    },

    template: rfpListTemplate,

    controller: function (
        $scope,
        $state,
        $stateParams,
        $ionicLoading,
        $ionicPopup,
        $ionicModal,
        MessageBox,
        filterHistory,
        $filter,
        $rootScope,
        ApiRfps
    ) {
        this.filterHistory = filterHistory;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.package = [];
        this.investorSubtypes = [];
        this.loading = [];
        this.moreData = false;
        this.loadingRfps = true;
        this.ApiRfps = ApiRfps;

        this.filterParameters = {
            assetClass: null,
            country: null,
            status: null,
            region: null,
            searchText: null,
        };

        this.filterParameterObj = {
            assetClass: undefined,
            country: undefined,
            deadline: undefined,
            issueDate: undefined,
            pageNumber: 0,
            region: undefined,
            requestIssuer: undefined,
            respondent: undefined,
            searchText: undefined,
            sortDirection: 'ASC',
            sortCriteria: 'ISSUE_DATE',
            status: undefined,
            type: undefined,
        };

        this.constants = {};

        this.modal = $ionicModal.fromTemplate(rfpListFilterModalTemplate, {
            scope: $scope,
        });

        var self = this;
        $rootScope.$on(
            '$stateChangeStart',
            function (event, toState, toParams, fromState, fromParam) {}
        );

        this.isFilterActive = () => {
            return (
                this.filterParameterObj.type ||
                this.filterParameterObj.status ||
                this.filterParameterObj.respondent ||
                this.filterParameterObj.region ||
                this.filterParameterObj.assetClass ||
                this.filterParameterObj.country
            );
        };

        this.$onInit = () => {
            this.showLoading();

            this.preLoadFilter();
            this.getFilterIndicationText();

            this.loadRfps();
        };

        this.getMore = () => {
            this.loadingRfps = true;
            this.filterParameterObj.pageNumber += 1;
            this.ApiRfps.getRfps(this.filterParameterObj).then((rfps) => {
                if (!rfps) {
                    this.moreData = false;
                } else {
                    this.moreData = rfps.length >= 50;
                    this.rfps = this.rfps.concat(rfps);
                    $scope.$broadcast('scroll.infiniteScrollComplete');
                }
                this.loadingRfps = false;
            });
        };

        this.preLoadFilter = () => {
            let filter = this.filterHistory.readFilter('rfp');
            if (filter) {
                this.filterParameters = filter;

                if (filter.assetClass) {
                    this.filterParameterObj.assetClass =
                        filter.assetClass.value;
                }

                if (filter.status) {
                    this.filterParameterObj.status = filter.status.value;
                }

                if (filter.region) {
                    this.filterParameterObj.region = filter.region.value;
                }

                if (filter.country) {
                    this.filterParameterObj.country = filter.country;
                }

                if (filter.searchText) {
                    this.filterParameterObj.searchText = filter.searchText;
                    this.searchText = filter.searchText;
                }
            }

            this.ApiRfps.getConstants().then((constants) => {
                this.constants = constants || {};
            });
        };

        this.showLoading = () => {
            this.loading.push(1);
            $ionicLoading.show({
                template: '<spinner-advinda></spinner-advinda>',
            });
        };

        this.hideLoading = () => {
            this.loading.pop();
            if (this.loading.length === 0) $ionicLoading.hide();
        };

        this.onSearch = (search) => {
            this.filterParameterObj.searchText = search;
            this.filterParameters.searchText = search;

            this.onFilter();
        };

        this.getFilterIndicationText = () => {
            let filter = this.filterParameterObj;
            let text = '';
            if (!filter) return '';
            if (this.filterParameterObj.type) {
                text = text + $filter('translate')('TYPE') + ', ';
            }
            if (this.filterParameterObj.status) {
                text = text + $filter('translate')('STATUS') + ', ';
            }
            if (this.filterParameterObj.respondent) {
                text = text + $filter('translate')('RESPONDENT') + ', ';
            }
            if (this.filterParameterObj.region) {
                text = text + $filter('translate')('REGION') + ', ';
            }
            if (this.filterParameterObj.assetClass) {
                text = text + $filter('translate')('ASSET_CLASS') + ', ';
            }
            if (this.filterParameterObj.country) {
                text = text + $filter('translate')('STATE_COUNTRY') + ', ';
            }
            if (text.length > 0) {
                text = 'Filter by: ' + text.substring(text.length - 2, 0);
            }
            this.filterIndicationText = text;
        };

        this.loadRfps = () => {
            this.ApiRfps.getRfps(this.filterParameterObj).then((rfps) => {
                if (rfps.length < 50) {
                    this.moreData = false;
                } else {
                    this.moreData = true;
                }

                this.rfps = rfps || [];

                this.loadingRfps = false;

                this.hideLoading();
            });
        };

        this.onSort = (field, order) => {
            this.filterParameterObj.sortDirection = order;
            this.filterParameterObj.sortCriteria = field;

            this.onFilter();
        };

        this.onFilter = () => {
            if (
                this.filterParameters.assetClass &&
                this.filterParameters.assetClass !== ''
            ) {
                this.filterParameterObj.assetClass =
                    this.filterParameters.assetClass.value;
            } else {
                this.filterParameters.assetClass = null;
                this.filterParameterObj.assetClass = undefined;
            }

            if (
                this.filterParameters.status &&
                this.filterParameters.status !== ''
            ) {
                this.filterParameterObj.status =
                    this.filterParameters.status.value;
            } else {
                this.filterParameters.status = null;
                this.filterParameterObj.status = undefined;
            }

            if (
                this.filterParameters.region &&
                this.filterParameters.region !== ''
            ) {
                this.filterParameterObj.region =
                    this.filterParameters.region.value;
            } else {
                this.filterParameters.region = null;
                this.filterParameterObj.region = undefined;
            }

            if (
                this.filterParameters.country &&
                this.filterParameters.country !== ''
            ) {
                this.filterParameterObj.country = this.filterParameters.country;
            } else {
                this.filterParameters.country = null;
                this.filterParameterObj.country = undefined;
            }

            this.filterParameterObj.pageNumber = 0;

            this.loadRfps();
            this.filterHistory.saveFilter(
                angular.copy(this.filterParameters),
                'rfp'
            );
            this.getFilterIndicationText();
            this.closeModal();
        };

        // Show filter modal box
        this.openModal = () => {
            this.updateDisable(true);
            var self = this;
            this.modal.scope.$on('modal.hidden', () => {
                self.updateDisable(false);
            });

            this.filterParameters.region = this.getConstant(
                this.constants.region,
                this.filterParameterObj.region
            );
            this.filterParameters.country = this.filterParameterObj.country;
            this.filterParameters.status = this.getConstant(
                this.constants.status,
                this.filterParameterObj.status
            );
            this.filterParameters.assetClass = this.getConstant(
                this.constants.assetClass,
                this.filterParameterObj.assetClass
            );

            this.modal.show();
        };

        // Close filter modal box
        this.closeModal = () => {
            this.modal.hide();
        };

        this.cancelModal = () => {
            this.closeModal();
        };

        /*
        this.removeType = () => {
            this.filterParameterObj.type = undefined;
            this.onFilter();
        };
         */

        this.removeStatus = () => {
            this.filterParameterObj.status = undefined;
            this.filterParameters.status = null;

            this.onFilter();
        };

        /*
        this.removeRespondent = () => {
            this.filterParameterObj.respondent = undefined;
            this.onFilter();
        };
         */

        this.removeRegion = () => {
            this.filterParameterObj.region = undefined;
            this.filterParameters.region = null;

            this.onFilter();
        };

        this.removeCountry = () => {
            this.filterParameterObj.country = undefined;
            this.filterParameters.country = null;

            this.onFilter();
        };

        this.removeAssetClass = () => {
            this.filterParameterObj.assetClass = undefined;
            this.filterParameters.assetClass = null;

            this.onFilter();
        };

        this.removeAllFilters = () => {
            //this.filterParameterObj.type = undefined;
            //this.filterParameterObj.respondent = undefined;

            this.filterParameterObj.status = undefined;
            this.filterParameters.status = null;

            this.filterParameterObj.region = undefined;
            this.filterParameters.region = null;

            this.filterParameterObj.assetClass = undefined;
            this.filterParameters.assetClass = null;

            this.filterParameterObj.country = undefined;
            this.filterParameters.country = null;

            this.onFilter();
        };

        this.openLink = (url) => {
            var confirmPopup = $ionicPopup.confirm({
                title: $filter('translate')('OPEN_LINK'),
                template: $filter('translate')('OPEN_LINK_CONFIRM', {
                    url: url,
                }),
            });
            confirmPopup.then(function (res) {
                if (res) {
                    if ($rootScope.isIos) {
                        window.cordova.InAppBrowser.open(url, '_system');
                    } else {
                        window.open(url);
                    }
                }
            });
        };

        this.getConstantName = (list, value) => {
            let constant = null;
            if (list) {
                constant = list.find((item) => {
                    return item.value == value;
                });
            }

            return constant ? constant.name : '';
        };

        this.getConstant = (list, value) => {
            let constant = null;
            if (list) {
                constant = list.find((item) => {
                    return item.value == value;
                });
            }

            return constant;
        };
    },
};

export default rfpFilterModal;



/** WEBPACK FOOTER **
 ** ./src/app/directives/rfpList/rfpList.js
 **/